export default __webpack_public_path__ + "static/media/overview.922a0627.svg";